import React from 'react'
import HoursSelector from '../../hours/selector'
import { Form } from 'react-bootstrap'

const HourBox = ({
    label,
    value,
    onChange = () => {},
    placeholder
}) => {

    return (
        <Form.Group>
            <Form.Label>{label || 'Hour'}</Form.Label>
            <HoursSelector
                value={value}
                onChange={onChange}
                placeholder={placeholder}
            />
        </Form.Group>
    )
}

export default HourBox
